module.exports = __webpack_public_path__ + "img/icon2.2d2315a5.png";